var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComplete({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.39972 9.30896L9.81398 5.8947C9.96098 5.7478 9.96098 5.51031 9.81398 5.3634C9.66744 5.21649 9.42968 5.21649 9.28277 5.3634L6.13397 8.51219L4.69262 7.07084C4.54571 6.92393 4.30784 6.92393 4.16093 7.07084C4.0144 7.21775 4.0144 7.45524 4.16093 7.60214L5.86827 9.3091C5.94159 9.38241 6.03773 9.41921 6.13397 9.41921C6.23012 9.41921 6.32627 9.38241 6.39958 9.3091M6.99967 0.333496C3.31731 0.333496 0.333008 3.31876 0.333008 7.00016C0.333008 10.6825 3.31755 13.6673 6.99967 13.6673C10.6816 13.6673 13.6663 10.6825 13.6663 7.00016C13.6663 3.31876 10.6816 0.333496 6.99967 0.333496ZM6.99967 1.08492C10.261 1.08492 12.9149 3.73879 12.9149 7.00014C12.9149 10.262 10.261 12.9158 6.99967 12.9158C3.73784 12.9158 1.08446 10.262 1.08446 7.00014C1.08446 3.73879 3.73784 1.08492 6.99967 1.08492Z",
    fill: "#03A000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplete);
export default __webpack_public_path__ + "static/media/complete.fd873835a98a6653417a01e95c31beea.svg";
export { ForwardRef as ReactComponent };